import React from 'react';
import { Typography } from 'fronton-react';
import { GlobeIcon, LemanaProLogoSimpleIcon } from '@fronton/icons-react';
import { CasesList, HowToUseWrapper, Case, CaseColumn } from './styles';
import { useTranslation } from 'react-i18next';

export const HowToUse = () => {
  const { t } = useTranslation();

  return (
    <HowToUseWrapper>
      <Typography variant="h3">{t('loyalty-registration-modal.success-step.how-use')}</Typography>
      <CasesList>
        <Case>
          <CaseColumn>
            <LemanaProLogoSimpleIcon size="l" />
          </CaseColumn>
          <CaseColumn>{t('loyalty-registration-modal.success-step.tell-your-phone')}</CaseColumn>
        </Case>
        <Case>
          <CaseColumn>
            <GlobeIcon size="l" />
          </CaseColumn>
          <CaseColumn>{t('loyalty-registration-modal.success-step.online')}</CaseColumn>
        </Case>
      </CasesList>
    </HowToUseWrapper>
  );
};
